import { CHCTagPage } from './tag-page.component.js';
export { CHCTagPage };

customElements.define('chcapp-tag-page', CHCTagPage);

declare global {
  interface HTMLElementTagNameMap {
    'chcapp-tag-page': CHCTagPage;
  }
}
